<template>
    <div>
        <div>
            <div class="card p-2">
                <div class="text-center p-4 mb-4 bg-dark">
                    <span class="h1 font-weight-bold">
                        <i class="fa-solid fa-screwdriver-wrench mr-3"></i>
                        MANTENIMIENTO CORRECTIVO
                    </span>
                    <p class="mt-2">Registrar un nuevo mantenimiento correctivo para la Super Transporte.</p>
                </div>
                <div class="bg-dark p-1">
                    <PasoAPaso numero="1" descripcion="Paso 1, Adjuntar archivos (opcional)" class="w-100 mt-4">
                        <div class="p-4">
                            <h4 class="py-2 border-collapse font-weight-bold">Subir archivo</h4>
                            <DropFileBasic ref="DropFileBasic" @handleFileData="handleFileUpload"
                                @change="handleFileUpload" :fileTypes="['application/pdf']" />
                        </div>
                    </PasoAPaso>
                    <form @submit.prevent="guardarCorrectivo()">
                        <PasoAPaso numero="2" descripcion="Paso 2, Suministrar información mantenimiento"
                            class="w-100 mt-4">
                            <div class="row  align-items-start p-4">
                                <!-- Fecha -->
                                <div class="col-xl-6 mb-3">
                                    <label for="fecha" class="form-label">Fecha</label>
                                    <input v-model="formData.fecha" type="date" id="fecha" class="form-control"
                                        required />
                                </div>

                                <!-- Hora -->
                                <div class="col-xl-6 mb-3">
                                    <label for="hora" class="form-label">Hora</label>
                                    <input v-model="formData.hora" type="time" id="hora" class="form-control"
                                        required />
                                </div>


                                <!-- Tipo de Identificación -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacion" class="form-label">Tipo de Identificación</label>
                                    <select v-model="formData.tipoIdentificacion" id="tipoIdentificacion"
                                        class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Número de Identificación -->
                                <div class="col-xl-6 mb-3">
                                    <label for="formData.numeroIdentificacion" class="form-label">Número de
                                        Identificación</label>
                                    <input v-model="formData.numeroIdentificacion" type="number"
                                        id="numeroIdentificacion" class="form-control" required />
                                </div>

                                <!-- Nombres del Responsable -->
                                <div class="col-xl-6 mb-3">
                                    <label for="formData.nombresResponsable" class="form-label">Nombres del
                                        Responsable</label>
                                    <input v-model="formData.nombresResponsable" type="text" id="nombresResponsable"
                                        class="form-control" required />
                                </div>

                                <!-- Detalle de Actividades -->
                                <div class="col-xl-12 mb-3">
                                    <label for="formData.detalleActividades" class="form-label">Detalle de
                                        Actividades</label>
                                    <b-form-textarea v-model="formData.detalleActividades" id="detalleActividades"
                                        placeholder="Describe las actividades realizadas en el mantenimiento" rows="3"
                                        minlength="10" maxlength="550" required />
                                </div>
                            </div>
                        </PasoAPaso>
                        <!-- Botón Guardar -->
                        <div class="d-flex justify-content-end">
                            <vs-button type="submit" animation-type="vertical">
                                Guardar Registro
                                <template #animate>
                                    <i class="fas fa-plus-circle"></i>
                                </template>
                            </vs-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2"
import { mapGetters } from 'vuex'
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
import PasoAPaso from './PasoAPaso.vue';

export default {
    components: {
        DropFileBasic,
        PasoAPaso
    },
    props: {
        infoComplementaria: {
            type: Object,
            required: true
        },
        idMantenimiento: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            tipoIdentificaciones: [],
            selectedTipoIdentificacion: "",
            titleNuevoRegistro: 'Nuevo mantenimiento correctivo',
            ultimoRegistroActivo: null,
        }
    },
    computed: {
        ...mapGetters(['useMoment']),

        formData() {
            return {
                placa: this.infoComplementaria.placa,
                fecha: null,
                hora: null,
                nit: this.infoComplementaria.vigiladoId,
                razonSocial: "Helexium Test imp",
                tipoIdentificacion: null,
                numeroIdentificacion: null,
                nombresResponsable: null,
                mantenimientoId: this.idMantenimiento,
                detalleActividades: null,
            };
        }


    },
    async mounted() {

        // const schema = await this.$store.dispatch('getHojaDeVidaVehiculoMantenimientosRealizados', this.empresaId)
        // this.formData = schema.reduce((obj, item) => ({ ...obj, [item.name]: '' }), {})

        // const resProv = await this.$store.getters.fetchGet({ path: `VehiculoProveedorMantenimientos/Proveedores/${this.empresaId}` })
        // this.proveedores = await resProv.json()

        //await this.getHistorial()
        console.log(this.infoComplementaria);
        console.log(this.idMantenimiento);
        await this.obtenerTiposIdentificacion();
    },
    methods: {

        async handleFileUpload(file) {
            if (!file) return;

            if (file.type !== 'application/pdf') {
                this.mostrarNotificacion('error', 'Archivo inválido', 'Solo se permiten archivos PDF.');
                return;
            }

            // Previsualizar PDF o guardarlo en el estado// luego lo puedes mostrar en un iframe o <embed>
            const archivo = file;

            const resultadoSubirArchivo = await this.$store.dispatch('hl_post_file_cookie', {
                path: `ApiSuperTransporteMantenimientos/subir-archivo?idVigilado=${this.infoComplementaria.vigiladoId}&tipoMantenimiento=${this.infoComplementaria.tipoId}&soloSubir=true`,
                data: archivo
            })
            if (resultadoSubirArchivo) {
                this.$vs.notification({
                    progress: "auto",
                    icon: `<i class='fas fa-exclamation-circle'></i>`,
                    color: "success",
                    position: "top-right",
                    title: "Éxito",
                    text: "El archivo ha sido cargado en la Super Transporte Exitosamente",
                });
            }

        },
        async obtenerTiposIdentificacion() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de identificación
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-identificaciones",
                });

                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoIdentificaciones = response.filter(item => item.estado === true);
                    //console.log("Tipos de identificación filtrados:", this.tipoIdentificaciones);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener tipos de identificación:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },


        async guardarCorrectivo() {
            if (!this.infoComplementaria.placa) {
                Swal.fire('Error', 'No se ha especificado la placa del vehículo', 'error');
                return;
            }

            try {
                this.isLoading = true;

                // Preparar los datos para el registro
                const datosRegistro = this.formData

                console.log("Enviando datos:", datosRegistro);

                // Registrar el mantenimiento/autorización
                const resultado = await this.$store.dispatch('hl_post_cookie', {
                    path: `ApiSuperTransporteMantenimientos/registrar-correctivo`,
                    data: datosRegistro
                })

                console.log("Respuesta del servidor:", resultado);

                this.$emit('consultarMantenimientos')

                if (resultado.errors) {
                    Swal.fire({
                        icon: "error",
                        title: "¡Ups! No se ha registrado el mantenimiento",
                        text: `No se ha registrado el mantenimiento, por favor validar los campos`,
                        confirmButtonText: "Aceptar",
                    });
                }
                else {
                    Swal.fire({
                        icon: "success",
                        title: "Registro exitoso",
                        text: `Se ha registrado el mantenimiento preventivo`,
                        confirmButtonText: "Aceptar",
                    });
                }
            } catch (error) {
                console.error("Error al registrar:", error);
                this.errorMessage = error.message || "Error desconocido";
                this.registrationStatus = 'error';

                Swal.fire({
                    icon: 'error',
                    title: 'Error al registrar',
                    text: this.errorMessage,
                    confirmButtonText: 'Aceptar'
                });
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>

<style scoped>
.image-link img {
    max-width: 100px;
    max-height: 100px;
}

.border-collapse {
    border-bottom: .5px solid #dee2e6;
}
</style>